import { Calendar } from "lucide-react";
import { useEffect, useState } from "react";
import styled from "styled-components";

interface DateInputProps {
  label?: string;
  initialValue?: string;
  name: string;
  onChange?: (date: string) => void;
  required?: boolean
  disabled?: boolean
}

export const InputData = ({ label = "Início", initialValue = "", name, onChange, required, disabled }: DateInputProps) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue); 
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <InputContainer>
      <Label>{label}</Label>
      <InputWrapper>
        <IconWrapper>
          <Calendar size={20} />
        </IconWrapper>
        <Input
          type="date"
          value={value}
          onChange={handleChange}
          name={name}
          required={required}
          disabled={disabled}
        />
      </InputWrapper>
    </InputContainer>
  );
}



const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    max-width: 200px;
  `;

const Label = styled.label`
    font-size: 14px;
    color: #333;
  `;

const InputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
  `;

const Input = styled.input`
    width: 100%;
    padding: 8px 12px;
    padding-left: 36px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
  
    &:focus {
      border-color: #007bff;
    }
  
    &::-webkit-calendar-picker-indicator {
      display: none;
    }
  `;

const IconWrapper = styled.div`
    position: absolute;
    left: 8px;
    color: #666;
    pointer-events: none;
  `;